import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { FormInstance } from 'antd';

export function validateEmployeeCode(formInstance: FormInstance, isAnonymous: boolean): boolean {
	if (isAnonymous) return true;

	const employeeCode = formInstance.getFieldValue('employee_code');
	if (!employeeCode) {
		message.error(I18n.get('Please enter employee code'));
		return false;
	}
	return true;
}
